<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Pollen Lab Quality Control"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>Pollen Bottle QR Code</td>
                        <td>{{ detailInfo.pollenBottle.qrCode.code }}</td>
                    </tr>
                    <tr>
                        <td>Stage</td>
                        <td>{{ detailInfo.testingStage || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Weight (g)</td>
                        <td>{{ detailInfo.weight }}</td>
                    </tr>
                    <tr>
                        <td>Viability (%)</td>
                        <td>{{ detailInfo.viabilityPercentage || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Test Date</td>
                        <td>{{ detailInfo.testDate || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Image</td>
                        <td>
                            <image-holder :images="detailInfo.recordingImages" />
                        </td>
                    </tr>
                    <tr>
                        <td>Remarks</td>
                        <td>{{ detailInfo.remarks || "-" }}</td>
                    </tr>
                </table>
            </div>
            
            <p class="detail-title detail-title-pd">Pollen Bottle</p>
            <pollen-lab-quality-control-simple-table ref="labQC" :pollen-bottle-id="detailInfo.pollenBottleId" />

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { pollenBottleViabilityTestGet } from "@/api/pollen_bottle_viability_test";
import ImageHolder from "@/components/SidebarDetail/ImageHolder";
import PollenLabQualityControlSimpleTable from "@/components/PollenBottle/PollenLabQualityControlSimpleTable";

export default {
    components: {
        "detail-header": DetailHeader,
        "image-holder": ImageHolder,
        "pollen-lab-quality-control-simple-table": PollenLabQualityControlSimpleTable,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,
            mc: null
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo?.pollen?.qrCode?.code || "-";
        } 
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await pollenBottleViabilityTestGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
            if (this.$refs["labQC"]) {
                this.$refs["labQC"].getPollenBottles();
            }
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/PollenQualityControlSidebar.vue